import cssBreakpointVariables from '../../Scss/Abstracts/Variables/Scss/BootstrapOverride/_Breakpoints.scss'

export default class MediaQuery {
    static UpMd = window.matchMedia(`(min-width: ${cssBreakpointVariables.breakpointMedium})`).matches
}
